import { useRef, useState } from "react";

export function PrintManager() {
  const [senha, setSenha] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showSenha, setShowSenha] = useState(false);

  // Ref para fullscreen
  const containerRef = useRef<HTMLDivElement>(null);

  function handleEnterFullscreen() {
    const el = containerRef.current;
    if (el && el.requestFullscreen) {
      el.requestFullscreen();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } else if (el && (el as any).webkitRequestFullscreen) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (el as any).webkitRequestFullscreen();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } else if (el && (el as any).msRequestFullscreen) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (el as any).msRequestFullscreen();
    }
  }

  async function gerarSenha() {
    const printManagerUrl = localStorage.getItem('print-manager-url');
    const printManagerPrinter = localStorage.getItem('print-manager-printer');

    if (printManagerUrl == null) {
      setError('Configuração de rede não encontrada. Por favor, configure o Print Manager antes de gerar senhas.');
      setTimeout(() => setError(null), 6000);
      return;
    }

    if (printManagerPrinter == null) {
      setError('Impressora não configurada. Por favor, configure uma impressora antes de gerar senhas.');
      setTimeout(() => setError(null), 6000);
      return;
    }

    const urlBase = printManagerUrl;
    const atual = parseInt(sessionStorage.getItem('print-manager') || '0', 10);
    const proximo = atual + 1;

    const senhaFormatada = proximo.toString().padStart(7, '0');
    setSenha(senhaFormatada);
    setLoading(true);
    setShowSenha(false);

    const texto = `\n\n   LOCAVIBE\n\n  SENHA: ${senhaFormatada}\n\n${new Date().toLocaleDateString()} - ${new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}\n\n Seja bem-vindo!\n\nn\n`;

    try {
      await fetch(`${urlBase}/print`, {
        method: "POST",
        headers: {
          "accept": "*/*",
          "content-type": "application/json"
        },
        body: JSON.stringify({
          printerName: printManagerPrinter,
          text: texto,
          settings: {
            fontName: "Arial",
            fontSize: 8,
            fontStyle: 0,
            alignment: 1,
            bold: false,
            italic: false,
            underline: false,
            paperSize: 6,
            orientation: 0,
            margins: {
              top: 20,
              bottom: 50,
              left: 12,
              right: 12
            },
            textColor: { r: 0, g: 0, b: 0 },
            lineSpacing: 4,
            fitToPage: true,
            wrapText: false,
            maxLinesPerPage: 40
          }
        })
      });

      setShowSenha(true);
      sessionStorage.setItem('print-manager', proximo.toString());
      setTimeout(() => {
        setShowSenha(false);
        setSenha(null);
      }, 5000);
    } catch (error) {
      console.error(error);
      setSenha(null);
      setError('Erro ao enviar a impressão. Verifique a conexão com o Print Manager.');
      setTimeout(() => setError(null), 6000);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {/* Alerta customizado de erro */}
      {error && (
        <div
          style={{
            position: "fixed",
            top: 32,
            left: "50%",
            transform: "translateX(-50%)",
            background: "#e14231",
            color: "#fff",
            padding: "18px 32px",
            borderRadius: 12,
            boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
            fontWeight: 600,
            fontSize: 18,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
          role="alert"
        >
          <span style={{ fontSize: 22 }}>⚠️</span>
          <span>{error}</span>
          <button
            onClick={() => setError(null)}
            style={{
              marginLeft: 24,
              background: "rgba(255,255,255,0.15)",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              padding: "4px 12px",
              cursor: "pointer",
              fontWeight: 700,
              fontSize: 16,
            }}
          >
            Fechar
          </button>
        </div>
      )}

      <div
        style={{
          minHeight: "100vh",
          minWidth: "100vw",
          background: "#111",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Inter, Arial, sans-serif",
        }}
      >
        <div
          ref={containerRef}
          style={{
            background: "#fff",
            borderRadius: 24,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            padding: "48px 32px",
            minWidth: 340,
            maxWidth: 380,
            width: "100%",
            display: "grid",
            gap: 32,
            justifyItems: "center",
          }}
        >
          {/* Logo */}
          <img
            src="/logo.svg"
            alt="Logo"
            style={{ width: 80, marginBottom: 8, cursor: "pointer" }}
            onClick={handleEnterFullscreen}
          />

          {/* Moto */}
          <img
            src="/embaixador-moto-esquerda.svg"
            alt="Moto"
            style={{ width: 120, opacity: 0.85, cursor: "pointer" }}
            onClick={handleEnterFullscreen}
          />

          {/* Título */}
          <h2 style={{ margin: 0, fontWeight: 700, fontSize: 24, color: "#222" }}>
            Gerar Senha
          </h2>
          <p style={{ color: "#555", textAlign: "center", margin: 0 }}>
            Clique no botão abaixo para gerar uma nova senha para o motoboy.
          </p>

          {/* Botão */}
          <button
            onClick={gerarSenha}
            disabled={loading}
            style={{
              background: "linear-gradient(90deg, #e14231 0%, #ff6a3d 100%)",
              color: "#fff",
              fontWeight: 700,
              fontSize: 20,
              border: "none",
              borderRadius: 12,
              padding: "16px 32px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
              boxShadow: "0 2px 8px rgba(225,66,49,0.10)",
              transition: "transform 0.1s",
            }}
          >
            {loading ? "Imprimindo..." : "Gerar Senha"}
          </button>

          {/* Loading Spinner */}
          {loading && (
            <div style={{ marginTop: 16 }}>
              <div
                style={{
                  border: "4px solid #f3f3f3",
                  borderTop: "4px solid #e14231",
                  borderRadius: "50%",
                  width: 40,
                  height: 40,
                  animation: "spin 1s linear infinite"
                }}
              />
              <style>
                {`
                  @keyframes spin {
                    0% { transform: rotate(0deg);}
                    100% { transform: rotate(360deg);}
                  }
                `}
              </style>
            </div>
          )}

          {/* Senha gerada */}
          {showSenha && senha && (
            <div
              style={{
                marginTop: 16,
                fontSize: 32,
                fontWeight: 800,
                letterSpacing: 4,
                color: "#e14231",
                background: "#f8eaea",
                borderRadius: 8,
                padding: "12px 24px",
                boxShadow: "0 1px 4px rgba(225,66,49,0.07)",
              }}
            >
              {senha}
            </div>
          )}
        </div>
      </div>
    </>
  );
}